import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Countdown from "../components/Countdown";
import OurStory from "../components/OurStory";
import Venue from "../components/Venue";
import Itinerary from "../components/Itinerary";
import Travel from "../components/Travel";
import Stay from "../components/Stay";
import Registry from "../components/Registry";
import Gallery from "../components/Gallery";
import GuestLookup from "../components/GuestLookup";
import Guestbook from "../components/Guestbook";
import RSVP from "../components/RSVP";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";

export default function WeddingHome() {
  return (
    <div className="bg-[#F4EFE6] text-left">
      <Navbar />
      <Hero />
      <Countdown />
      <OurStory />
      <Venue />
      <Itinerary />
      <Travel />
      <Stay />
      <Registry />
      <GuestLookup />
      <Gallery />
      <Guestbook />
      <RSVP />
      <FAQ />
      <Footer />
    </div>
  );
}
